<nz-modal
  [(nzVisible)]="isVisible"
  [nzFooter]="null"
  nzTitle="Individual Details"
  [nzWidth]="900"
  (nzOnCancel)="modal.destroy()"
  class="individual-details-modal"
>
  <div class="details-modal-body" *nzModalContent>
    <div class="sidebar">
      <div class="flex-col-12">
        <nz-avatar [nzIcon]="'user'" class="avatar"></nz-avatar>
        <div>
          <div class="name-line">
            {{ individual.firstName }}
            <span *ngIf="individual.middleName"> {{ individual.middleName }} </span>
            {{ individual.lastName }}
          </div>
          <div class="email-line">
            {{ individual.email || '—' }}
          </div>
        </div>
      </div>

      <div nz-flex nzAlign="center" class="status-info" *ngIf="individual.kycData">
        <div class="status-dot"
             [class.status-dot-complete]="individual.kycData?.statusEnum === KycStatus.APPROVED"
             [class.status-dot-incomplete]="individual.kycData?.statusEnum !== KycStatus.APPROVED">
        </div>
        <div class="text-ink">
          <div>{{ getKycStatus(individual.kycData?.statusEnum || KycStatus.INCOMPLETE) }}</div>
        </div>
      </div>

      <nz-divider class="divider-tight"/>
      <div>
        <p class="roles-title">Roles</p>
        <div class="roles-wrap">
          <div class="role-item">
            <span class="role-badge" *ngIf="isPayer">
              {{ 'Payer' }}
            </span>
            <span class="role-badge" *ngIf="isRecipient">
              {{ 'Recipient' }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="details-content">
      <nz-tabset>
        <nz-tab nzTitle="General">
          <div class="pad-24">

            <!-- Personal Details -->
            <div class="mb-2">
              <div class="section-title">Personal Details</div>
              <div class="section-box">
                <div nz-row class="row dashed">
                  <div nz-col nzSpan="11" class="col-label">
                    <span>Resident or Non-Resident of Kazakhstan</span>
                  </div>
                  <div nz-col nzSpan="13" class="col-value">
                    <span>{{ individual.isResident ? 'Resident' : 'Non-Resident' }}</span>
                  </div>
                </div>

                <div nz-row class="row dashed">
                  <div nz-col nzSpan="11" class="col-label">
                    <span>First name</span>
                  </div>
                  <div nz-col nzSpan="13" class="col-value">
                    <span>{{ individual.firstName }}</span>
                  </div>
                </div>

                <div nz-row class="row dashed">
                  <div nz-col nzSpan="11" class="col-label">
                    <span>Patronymic name</span>
                  </div>
                  <div nz-col nzSpan="13" class="col-value">
                    <span>{{ individual.middleName || '—' }}</span>
                  </div>
                </div>

                <div nz-row class="row dashed">
                  <div nz-col nzSpan="11" class="col-label">
                    <span>Last name</span>
                  </div>
                  <div nz-col nzSpan="13" class="col-value">
                    <span>{{ individual.lastName }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Identity Document -->
            <div *ngIf="individual.identityDocument" class="mb-2">
              <div class="section-title">Identity Document</div>
              <div class="section-box">
                <div nz-row class="row dashed">
                  <div nz-col nzSpan="11" class="col-label">
                    <span>Identity document number</span>
                  </div>
                  <div nz-col nzSpan="13" class="col-value">
                    <span>{{ individual.identityDocument.docNumber }}</span>
                  </div>
                </div>

                <div nz-row class="row dashed" *ngIf="isResident()">
                  <div nz-col nzSpan="11" class="col-label">
                    <span>IIN</span>
                  </div>
                  <div nz-col nzSpan="13" class="col-value">
                    <span>{{ individual.identityDocument.iin }}</span>
                  </div>
                </div>

                <div nz-row class="row dashed">
                  <div nz-col nzSpan="11" class="col-label">
                    <span>Country of citizenship</span>
                  </div>
                  <div nz-col nzSpan="13" class="col-value">
                    <span>{{ individual.identityDocument.country?.name }}</span>
                  </div>
                </div>

                <div nz-row class="row" *ngIf="!isResident()">
                  <div nz-col nzSpan="11" class="col-label">
                    <span>Tax registration number in the country of incorporation</span>
                  </div>
                  <div nz-col nzSpan="13" class="col-value">
                    <span>{{ individual.identityDocument.vatNumber }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Contact Details -->
            <div class="mb-2">
              <div class="section-title">Contact Details</div>
              <div class="section-box">
                <div nz-row class="row dashed">
                  <div nz-col nzSpan="11" class="col-label">
                    <span>Email</span>
                  </div>
                  <div nz-col nzSpan="13" class="col-value">
                    <span>{{ individual.email }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Address Details -->
            <div *ngIf="individual.address" class="mb-2">
              <div class="section-title">Address Details</div>
              <div class="section-box">
                <div nz-row class="row dashed">
                  <div nz-col nzSpan="11" class="col-label">
                    <span>Country of main residence</span>
                  </div>
                  <div nz-col nzSpan="13" class="col-value">
                    <span>{{ individual.address.country?.name || '—' }}</span>
                  </div>
                </div>

                <div nz-row class="row dashed">
                  <div nz-col nzSpan="11" class="col-label">
                    <span>Postal code</span>
                  </div>
                  <div nz-col nzSpan="13" class="col-value">
                    <span>{{ individual.address.postalCode }}</span>
                  </div>
                </div>

                <div nz-row class="row dashed">
                  <div nz-col nzSpan="11" class="col-label">
                    <span>City</span>
                  </div>
                  <div nz-col nzSpan="13" class="col-value">
                    <span>{{ individual.address.city }}</span>
                  </div>
                </div>

                <div nz-row class="row dashed">
                  <div nz-col nzSpan="11" class="col-label">
                    <span>Street</span>
                  </div>
                  <div nz-col nzSpan="13" class="col-value">
                    <span>{{ individual.address.street }}</span>
                  </div>
                </div>

                <div nz-row class="row dashed">
                  <div nz-col nzSpan="11" class="col-label">
                    <span>Building number</span>
                  </div>
                  <div nz-col nzSpan="13" class="col-value">
                    <span>{{ individual.address.buildingNumber }}</span>
                  </div>
                </div>

                <div nz-row class="row">
                  <div nz-col nzSpan="11" class="col-label">
                    <span>Office/Flat</span>
                  </div>
                  <div nz-col nzSpan="13" class="col-value">
                    <span>{{ individual.address.officeRoomNumber }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nz-tab>
        <nz-tab nzTitle="Documents">
          <div class="document-list">
            <div *ngIf="kycReport">
              <div class="document-group-title">
                <span>KYC report</span>
              </div>
              <div class="document-item">
                <div class="document-info">
                  <i nz-icon [nzType]="'paper-clip'" class="document-icon"></i>
                  <a class="document-link" (click)="previewFile(kycReport)">{{ kycReport.fileName }}</a>
                </div>
                <div>
                  <span class="document-date">{{ kycReport.createdAt| date:'dd.MM.yyyy' }}</span>
                </div>
              </div>
            </div>
            <div *ngIf="kycIdentityDocs && kycIdentityDocs.length > 0">
              <div class="document-group-title">
                <span>ID Document</span>
              </div>
              <div class="document-item" *ngFor="let doc of kycIdentityDocs">
                <div class="document-info">
                  <i nz-icon [nzType]="'paper-clip'" class="document-icon"></i>
                  <a class="document-link" (click)="previewFile(doc)">{{ doc.fileName }}</a>
                </div>
                <div>
                  <span class="document-date">{{ doc.createdAt | date:'dd.MM.yyyy' }}</span>
                </div>
              </div>
            </div>
          </div>
        </nz-tab>
      </nz-tabset>
    </div>
  </div>
</nz-modal>
